module.exports = __webpack_public_path__ + "static/sidebar-c3dcc1eccd007b59d72bf26277b85b62.png";